module.exports = __webpack_public_path__ + "img/zoo.6bbcb143.jpeg";